// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".html-container[data-v-4fb4cbf3] h1{margin-bottom:12px}.html-container[data-v-4fb4cbf3] h2{margin-bottom:8px}.html-container[data-v-4fb4cbf3] h3{margin-bottom:4px}.html-container[data-v-4fb4cbf3] a{font-weight:600}.html-container[data-v-4fb4cbf3] table{border-collapse:collapse;width:100%;margin:8px auto}.html-container[data-v-4fb4cbf3] table th{border:1px solid #000}.html-container[data-v-4fb4cbf3] table td{text-align:center;border:1px solid #000}", ""]);
// Exports
module.exports = exports;
